module.exports = __webpack_public_path__ + "img/9788952779663.5d58a7e0.jpg";